import {BussinessLine, type BussinessLineData} from "@/types/site_admin/bussiness-lines";

export class OrderEntryFeature {
    public id:number|null;
    public is_order_feature:boolean;
    public enabled:boolean;
    public feature_number:number;
    public name:string;
    public description:string;
    public tooltip:string;
    public revenue_feature_international:string|null;
    public cost_feature_international:string|null;
    public planboard_visible_international:string|null;
    public feature_plancheck_international:string|null;
    public revenue_feature_domestic:string|null;
    public cost_feature_domestic:string|null;
    public planboard_visible_domestic:string|null;
    public feature_plancheck_domestic:string|null;
    public businessLines:BussinessLine[];

    constructor(data:OrderEntryFeatureData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.is_order_feature = false;
            this.enabled = true;
            this.feature_number = 0;
            this.name = "";
            this.description = "";
            this.tooltip = "";
            this.revenue_feature_international = null;
            this.cost_feature_international = null;
            this.planboard_visible_international = null;
            this.feature_plancheck_international = null;
            this.revenue_feature_domestic = null;
            this.cost_feature_domestic = null;
            this.planboard_visible_domestic = null;
            this.feature_plancheck_domestic = null;
            this.businessLines = [];
        }
        else
        {
            this.feature_number = data.feature_number;
            this.is_order_feature = data.is_order_feature;
            this.enabled = data.enabled ?? true;
            this.id = data.id;
            this.name = data.name;
            this.description = data.description;
            this.tooltip = data.tooltip;
            this.revenue_feature_international = data.revenue_feature_international;
            this.cost_feature_international = data.cost_feature_international;
            this.planboard_visible_international = data.planboard_visible_international;
            this.feature_plancheck_international = data.feature_plancheck_international;
            this.revenue_feature_domestic = data.revenue_feature_domestic;
            this.cost_feature_domestic = data.cost_feature_domestic;
            this.planboard_visible_domestic = data.planboard_visible_domestic;
            this.feature_plancheck_domestic = data.feature_plancheck_domestic;
            this.businessLines = [];
            if (data.businessLines !== undefined) {
                data.businessLines.forEach(bl => this.businessLines.push(new BussinessLine(bl)));
            }
        }
    }

    serializeData():OrderEntryFeatureData {
        return {
            id: this.id,
            is_order_feature: this.is_order_feature,
            enabled: this.enabled,
            feature_number: this.feature_number,
            name: this.name,
            description: this.description,
            tooltip: this.tooltip,
            revenue_feature_international: this.revenue_feature_international,
            cost_feature_international: this.cost_feature_international,
            planboard_visible_international: this.planboard_visible_international,
            feature_plancheck_international: this.feature_plancheck_international,
            revenue_feature_domestic: this.revenue_feature_domestic,
            cost_feature_domestic: this.cost_feature_domestic,
            planboard_visible_domestic: this.planboard_visible_domestic,
            feature_plancheck_domestic: this.feature_plancheck_domestic,
            businessLines: this.businessLines.map(bl => (typeof (bl as any).serializeData === "function") ? bl.serializeData() : bl),
        }
    }
}

export type OrderEntryFeatureData = {
    id:number|null;
    is_order_feature:boolean;
    enabled:boolean;
    feature_number:number;
    name:string;
    description:string;
    tooltip:string;
    revenue_feature_international:string|null;
    cost_feature_international:string|null;
    planboard_visible_international:string|null;
    feature_plancheck_international:string|null;
    revenue_feature_domestic:string|null;
    cost_feature_domestic:string|null;
    planboard_visible_domestic:string|null;
    feature_plancheck_domestic:string|null;
    businessLines?:BussinessLineData[];
}